import isArray from "lodash/isArray";
import mergeWith from "lodash/mergeWith";

const customizer = (object: any, source: any, key: string) => {
    if (isArray(object)) {
        return source;
    }
};

const overrideProps = <TObject1, TObject2>(object1: TObject1, object2: TObject2): TObject1 & TObject2 => {
    return mergeWith({}, object1, object2, customizer);
};

export default overrideProps;
